"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var i18next = require("i18next");
var i18nextXHRBackend = require("i18next-xhr-backend");
var jqueryI18next = require("jquery-i18next");
var config_1 = require("./config");
var $ = require("jquery");
i18next.use(i18nextXHRBackend).init({
    fallbackLng: "es",
    debug: false,
    backend: {
        loadPath: 
        //'../' +
        //window.location.pathname
        //.split('/')
        //.slice(2, -1)
        //.join('/') +
        "./assets/i18n/{{lng}}.json"
    }
}, function (err, t) {
    jqueryI18next.init(i18next, $);
    $(function () {
        updateContent();
    });
});
function updateContent() {
    $("#step1").localize();
    $("#step2").localize();
    $("#step3").localize();
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="tooltip"]').each(function () {
        var title = $(this).attr("title");
        if (title.length != 0) {
            $(this).attr("data-original-title", title);
        }
    });
    // Terms
    $("#modal-terms").load("./assets/i18n/conditions_" + getLanguage() + ".html");
    // Cups
    $("#modal-cups").load("./assets/i18n/cups_" + getLanguage() + ".html");
    // Errors
    $("#modal-error").load("./assets/i18n/error_" + getLanguage() + ".html");
}
function changeLng(lng) {
    i18next.changeLanguage(lng);
    setValidationMessages();
}
i18next.on("languageChanged", function () {
    updateContent();
});
function getLanguage() {
    var lang = i18next.default.options.fallbackLng[0];
    if (i18next.default.language != undefined) {
        lang = i18next.default.language;
    }
    return lang;
}
function setValidationMessages() {
    var lang = getLanguage();
    $("#step1Form").validate().settings.messages = {
        Address: config_1.config.formMessages[lang].Address,
        Province: config_1.config.formMessages[lang].Province,
        PostalCode: {
            required: config_1.config.formMessages[lang].PostalCode.required,
            pattern: config_1.config.formMessages[lang].PostalCode.pattern
        },
        Number: config_1.config.formMessages[lang].Number,
        City: config_1.config.formMessages[lang].City,
        Tariff: config_1.config.formMessages[lang].Tariff,
        ContractedPower: {
            required: config_1.config.formMessages[lang].ContractedPower.required,
            pattern: config_1.config.formMessages[lang].ContractedPower.pattern
        }
    };
    $("#step3Form").validate(lang).settings.messages = {
        Name: config_1.config.formMessages[lang].Name,
        LastName: config_1.config.formMessages[lang].LastName,
        Email: {
            required: config_1.config.formMessages[lang].Email.required,
            pattern: config_1.config.formMessages[lang].Email.pattern,
            email: config_1.config.formMessages[lang].Email.email,
            refEmail: config_1.config.formMessages[lang].Email.refEmail
        },
        Terms: config_1.config.formMessages[lang].Terms,
        documentNumber: {
            required: config_1.config.formMessages[lang].documentNumber.required,
            pattern: config_1.config.formMessages[lang].documentNumber.pattern,
            nifES: config_1.config.formMessages[lang].documentNumber.nifES,
            nieES: config_1.config.formMessages[lang].documentNumber.nieES,
            cifES: config_1.config.formMessages[lang].documentNumber.cifES
        },
        documentType: config_1.config.formMessages[lang].documentType,
        PhoneNumber: {
            required: config_1.config.formMessages[lang].PhoneNumber.required,
            minlength: config_1.config.formMessages[lang].PhoneNumber.minlength,
            number: config_1.config.formMessages[lang].PhoneNumber.number,
            phoneNumberEs: config_1.config.formMessages[lang].PhoneNumber.phoneNumberEs
        },
        CUPS: {
            required: config_1.config.formMessages[lang].CUPS.required,
            pattern: config_1.config.formMessages[lang].CUPS.pattern
        },
        ContactName: config_1.config.formMessages[lang].ContactName,
        ContactLastName: config_1.config.formMessages[lang].ContactLastName,
        ContactDocumentNumber: {
            required: config_1.config.formMessages[lang].ContactDocumentNumber.required,
            pattern: config_1.config.formMessages[lang].ContactDocumentNumber.pattern,
            nifES: config_1.config.formMessages[lang].ContactDocumentNumber.nifES,
            nieES: config_1.config.formMessages[lang].ContactDocumentNumber.nieES
        }
    };
}
exports.setValidationMessages = setValidationMessages;
